import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { FormattedMessage } from 'react-intl';

import {
    ImageSizesByType,
    Sizes,
} from '@ratehub/base-ui';



function RateLogo({ isFeatured, provider, className }) {
    return (
        <Container className={className}>
            <LazyLoadImage
                className="logo rh-m-0"
                src={provider.logo}
                alt={provider.name}
                height={ImageSizesByType.PROVIDERS.BADGE_SMALL.HEIGHT}
                width={ImageSizesByType.PROVIDERS.BADGE_SMALL.WIDTH}
            />
            <If condition={isFeatured}>
                <p className="rh-text-2xs rh-fg-stone-darkest rh-m-0 rh-text-lowercase featured">
                    <FormattedMessage
                        id="mtg-common.RateLogo.featured"
                        defaultMessage="Featured"
                    />
                </p>
            </If>
            <p
                className="rh-fg-blackberry rh-text-m rh-m-0 name"
            >
                {provider.name}
            </p>
        </Container>
    );
}

RateLogo.propTypes = {
    isFeatured: PropTypes.bool.isRequired,
    provider: PropTypes.shape({
        name: PropTypes.string,
        logo: PropTypes.string,
    }).isRequired,
    className: PropTypes.string,
};

RateLogo.defaultProps = {
    className: undefined,
};

const Container = styled.div`
    display: grid;

    grid-template-columns: ${ImageSizesByType.PROVIDERS.BADGE_SMALL.WIDTH}px 1fr;
    grid-template-areas:
        ". featured"
        "logo name";

    column-gap: ${Sizes.SPACING.HALF};

    > .logo {
        grid-area: logo;

        justify-self: end;
        align-self: center;

        object-fit: contain;
    }

    > .featured {
        grid-area: featured;
    }

    > .name {
        grid-area: name;
        
        align-self: center;
    }
`;

export default RateLogo;